import { IonCol, IonIcon, IonRow } from "@ionic/react";
import { arrowBackOutline } from "ionicons/icons";
import { useHistory } from "react-router";

interface Props {
  pathReturn?: string;
}

const PathReturn: React.FC<Props> = ({ pathReturn }) => {
  const history = useHistory();

  return (
    <>
      {pathReturn && pathReturn.length > 0 && (
        <IonRow>
          <IonCol
            style={{ height: "45px" }}
            onClick={() => {
              if (window.location.pathname.includes("/videogen") === true) {
                window.location.href = "/generiques";
              } else if (
                window.location.pathname.includes("/generiques") ||
                window.location.pathname.includes("/competences")
              ) {
                history.push("/");
              } else if (window.location.pathname.includes("/video") === true) {
                history.push("/competences");
              } else {
                history.goBack();
              }
            }}
          >
            <IonIcon
              size="large"
              icon={arrowBackOutline}
              className="return-icon border-radius"
              color="white"
            ></IonIcon>
          </IonCol>
        </IonRow>
      )}
    </>
  );
};

export default PathReturn;
